import { Button } from '@sketchnote/shared-components';
import { Avatar } from '@sketchnote/shared-components';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { useAccountStore } from '../store';

export const PictureUpload = ({ onImageChange }: { onImageChange: (image: string) => void }) => {
  const { organizationImage, organization, setOrganizationImage, setOrganisationImageSize } =
    useAccountStore((state) => state);
  // Create a reference to the hidden file input element
  const hiddenFileInput = React.useRef<any>(null);
  // Programatically click the hidden file input element
  // when the Button component is clicked

  // const [image, setImage] = useState<any>();

  // useEffect(() => {
  //   setImage(organizationImage);
  // }, []);
  // useEffect(() => {
  //   onImageChange(image);
  // }, [image]);

  const imageURL = useMemo(() => {
    if (organizationImage instanceof File) {
      return URL.createObjectURL(organizationImage);
    }
  }, [organizationImage]);

  const handleClick = useCallback(() => {
    hiddenFileInput?.current?.click();
  }, []);

  const handleFileChange = useCallback((event) => {
    if (event.target.files?.length) {
      setOrganizationImage(event.target.files[0]);
      setOrganisationImageSize(event.target.files[0].size);
    }
  }, []);

  return (
    <div className="flex items-center">
      <Avatar
        name={organization}
        size="xl"
        type="photo"
        wrapperClassName="border"
        src={
          organizationImage
            ? organizationImage instanceof File
              ? imageURL
              : organizationImage
            : ''
        }
      />
      <div className="px-12">
        <div>
          <Button status="ghost" className="pl-0 pb-0 pt-0 mb-4" onClick={handleClick}>
            Upload photo
          </Button>
          {/* {profileImage && <span className="text-xs text-gray-600">{profileImage.name}</span>} */}
        </div>

        <input
          ref={hiddenFileInput}
          accept="image/*"
          className="hidden"
          id="file"
          multiple={false}
          type="file"
          onChange={handleFileChange}
        />
        <div className="text-xs text-gray-600">Maximum size 2MB</div>
      </div>
    </div>
  );
};
